import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Katalog',
  basePath: '/katalog',
  columns: [
    { key: 'company_name', label: 'Company', sortable: true },
    { key: 'katalog_marka', label: 'Brand', sortable: true },
    { key: 'katalog_nazwa', label: 'Name', sortable: true },
    { key: 'katalog_osoba', label: 'Person', sortable: true },
    { key: 'user_id', label: 'User', sortable: true },
    { key: 'archival', label: 'Archival', sortable: true },
  ],
  fields: [
    { key: 'company_id', label: 'Company', type: 'async-select',
      optionsUrl: '/companies/options', required: true },
    { key: 'katalog_marka', label: 'Brand', type: 'text' },
    { key: 'katalog_nazwa', label: 'Name', type: 'text' },
    { key: 'katalog_osoba', label: 'Person', type: 'text' },
    { key: 'katalog_adresf', label: 'Address (firm)', type: 'textarea' },
    { key: 'katalog_adresk', label: 'Address (correspondence)', type: 'textarea' },
    { key: 'katalog_portal_start', label: 'Portal Start', type: 'datetime' },
    { key: 'katalog_portal_end', label: 'Portal End', type: 'datetime' },
    { key: 'katalog_magazyn_start', label: 'Magazine Start', type: 'text' },
    { key: 'katalog_magazyn_end', label: 'Magazine End', type: 'text' },
    { key: 'katalog_woj', label: 'Region', type: 'text' },
    { key: 'katalog_uwagi', label: 'Notes', type: 'textarea' },
    { key: 'katalog_nip', label: 'NIP', type: 'text' },
    { key: 'user_id', label: 'User', type: 'text' },
    { key: 'archival', label: 'Archival', type: 'text' },
  ],
  defaultSort: { field: 'katalog_marka', dir: 'asc' },
});
